import { render, staticRenderFns } from "./FuneralPayment.vue?vue&type=template&id=11583cc3&scoped=true&"
import script from "./FuneralPayment.vue?vue&type=script&lang=js&"
export * from "./FuneralPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11583cc3",
  null
  
)

export default component.exports